import { useTranslation } from 'react-i18next'
import { HOURLY_RATE_TYPES, emptyStawkiGodzinowe } from '@/shared/hourlyRateTypes'

const inputClassName = 'block w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500'

export default function UserTrainerHourlyRateSection({ form, onChange }) {
	const { t } = useTranslation()
	const stawki = form.stawki_godzinowe || emptyStawkiGodzinowe()

	const updateRate = (code, value) => {
		const nextStawki = {
			...emptyStawkiGodzinowe(),
			...stawki,
			[code]: value,
		}
		onChange({
			stawki_godzinowe: nextStawki,
			stawka_godzinowa: nextStawki.U,
		})
	}

	return (
		<div className="rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm">
			<h2 className="text-sm font-semibold text-gray-900">
				{t('settingsPage.users.trainerModule.hourlyRateTitle')}
			</h2>
			<p className="mt-1 text-sm text-gray-500">
				{t('settingsPage.users.trainerModule.hourlyRatesDescription', {
					defaultValue: 'Ustaw domyślne stawki godzinowe brutto według kategorii szkolenia.',
				})}
			</p>

			<div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
				{HOURLY_RATE_TYPES.map(rateType => (
					<label key={rateType.code} className="flex flex-col gap-1">
						<span className="text-sm font-medium text-gray-700">
							{t(rateType.labelKey, { defaultValue: rateType.defaultLabel })}
						</span>
						<input
							type="number"
							min="0"
							step="0.01"
							value={stawki[rateType.code] ?? ''}
							onChange={event => updateRate(rateType.code, event.target.value)}
							placeholder={t('trainingTrainers.form.placeholders.defaultHourlyRateGross')}
							className={inputClassName}
						/>
					</label>
				))}
			</div>
		</div>
	)
}
